import { Component } from '@angular/core';

@Component({
  selector: 'app-descriptive-sub-header',
  imports: [],
  templateUrl: './descriptive-sub-header.html',
  styleUrl: './descriptive-sub-header.scss',
})
export class DescriptiveSubHeader {}
